export function formatRepAgencyRateDisplay(raw: string | null | undefined): string {
  if (raw == null || raw.trim() === "") {
    return "-";
  }
  const value = Number.parseFloat(raw);
  if (!Number.isFinite(value)) {
    return raw;
  }
  return `${(value * 100).toFixed(2).replace(/\.00$/, "")}%`;
}

export function parseRepAgencyRateInput(raw: string): number | null {
  const trimmed = raw.trim();
  if (trimmed === "") {
    return null;
  }
  if (trimmed.endsWith("%")) {
    const parsed = Number.parseFloat(trimmed.slice(0, -1));
    return Number.isFinite(parsed) ? parsed / 100 : null;
  }
  const parsed = Number.parseFloat(trimmed);
  if (!Number.isFinite(parsed)) {
    return null;
  }
  return parsed > 1 ? parsed / 100 : parsed;
}
